import axios from "axios";
import url from "../config/urlServiceConfig";

const subSoAPI = {
  getAll: () => axios.get(url.strategicSubObjective),
  getById: (id) => axios.get(`${url.strategicSubObjective}/${id}`),
  create: (body) => axios.post(url.strategicSubObjective, body),
  update: (body) => axios.put(url.strategicSubObjective, body),
  delete: (id) => axios.delete(`${url.strategicSubObjective}/${id}`),
  getAllWithKPIs: () => axios.get(`${url.strategicSubObjective}/KPIs`),
  getByIdWithKPIs: (id) => axios.get(`${url.strategicSubObjective}/KPIs/${id}`),
};

export default subSoAPI;
